import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import SaleDetailsPopup from './SaleDetailsPopup';
import BannerText from './BannerText';

const Wrapper = styled.div`
  background: ${props => props.$bgColor || (props.theme.old ? props.theme.colors.french : props.theme.colors.newPromo) };
  position: relative;

  .banner-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3px;

    .copy {
      text-align: center;
      color: ${props => props.$textColor || '#ffffff'};
    }
  }

  .banner-txt {
    text-align: center;
    color: ${props => props.$textColor || '#ffffff'};
  }

  .details-link {
    color: ${props => props.$textColor || '#ffffff'};
    text-decoration: underline;
  }

  .sale-page-link, .see-details-btn {
    color: ${props => props.$textColor || '#ffffff'};

    &:hover {
      color: ${props => props.$textColor || '#ffffff'};
    }
  }
`;

function NavBannerMobile({ className }) {
  const [open, setOpen] = useState(false);
  const [colors, setColors] = useState({ bgColor: null, textColor: null });
  const location = useLocation();
  const isAdminView = location.pathname.startsWith('/admin');
  const isLeaveReviews =
    location.pathname.startsWith('/reviews') && location.pathname.length > 9;

  const hideMobileBanner = isAdminView || isLeaveReviews;

  if (hideMobileBanner) return null;

  const toggle = () => {
    setOpen(!open);
  };

  return (
    <Wrapper className={className ? className : ''} id="nav-banner-mobile" $bgColor={colors.bgColor} $textColor={colors.textColor}>
      <div className="banner-content">
        <BannerText onClick={toggle} onColors={setColors} />
      </div>
      <SaleDetailsPopup open={open} toggle={toggle} />
    </Wrapper>
  );
}

export default NavBannerMobile;
